import { EnumDataType } from '../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { EnumPersistenceStatus } from '../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { EnumElementStatus } from '../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumElementStatus';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';

export abstract class BaseEntity {
  private _id: string;
  private _createdBy: string;
  private _createdOn: Date;
  private _modifiedBy: string;
  private _modifiedOn: Date;
  private _status: EnumElementStatus;
  private _persistenceStatus: EnumPersistenceStatus;
  private _owner: string;
  private _json: any; // 原始的JSON数据

  public get id() {
    return this._id;
  }

  public set id(value: string) {
    this._id = value;
  }

  public get createdBy() {
    return this._createdBy;
  }

  public set createdBy(value: string) {
    this._createdBy = value;
  }

  public get createdOn() {
    return this._createdOn;
  }

  public set createdOn(value: Date) {
    this._createdOn = value;
  }

  public get modifiedBy() {
    return this._modifiedBy;
  }

  public set modifiedBy(value: string) {
    this._modifiedBy = value;
  }

  public get modifiedOn() {
    return this._modifiedOn;
  }

  public set modifiedOn(value: Date) {
    this._modifiedOn = value;
  }

  public get status() {
    return this._status;
  }

  public set status(value: EnumElementStatus) {
    this._status = value;
  }

  public get persistenceStatus() {
    return this._persistenceStatus;
  }

  public set persistenceStatus(value: EnumPersistenceStatus) {
    this._persistenceStatus = value;
  }

  public set owner(value: string) {
    this._owner = value;
  }

  public get owner() {
    return this._owner;
  }

  public get json() {
    return this._json;
  }

  public set json(value: any) {
    this._json = value;
  }

  constructor() {
    this._id = '';
    this._createdBy = '';
    this._createdOn = new Date();
    this._modifiedBy = '';
    this._modifiedOn = new Date();
    this._status = EnumElementStatus.Valid;
    this._persistenceStatus = EnumPersistenceStatus.None;
    this._owner = '';
    this._json = null;
  }

  public copyFrom(element: BaseEntity, hasReference: boolean): void {
    if (element !== null) {
      this.id = element.id;
      this.createdBy = element.createdBy;
      this.createdOn = element.createdOn;
      this.modifiedBy = element.modifiedBy;
      this.modifiedOn = element.modifiedOn;
      this.status = element.status;
      this.persistenceStatus = element.persistenceStatus;
      this.owner = element.owner;
      this.json = element.json;
    }
  }

  protected Deserialize(json: any) {
    this.id = json.ID;
    this.createdBy = json.CreatedBy;
    this.createdOn = new Date(json.CreatedOn);
    this.modifiedBy = json.ModifiedBy;
    this.modifiedOn = new Date(json.ModifiedOn);
    this.status = json.Status as EnumElementStatus;
    this.persistenceStatus = json.PersistenceStatus as EnumPersistenceStatus;
    this.owner = json.Owner;
  }

  protected Serialize(json: any): void {
    json.ID = this.id;
    json.CreatedBy = this.createdBy;
    json.CreatedOn = this.createdOn;
    json.ModifiedOn = this.modifiedOn;
    json.ModifiedBy = this.modifiedBy;
    json.Status = this.status;
    json.PersistenceStatus = this.persistenceStatus;
    json.Owner = this.owner;
  }

  public toJson(): any {
    const json = {};
    this.Serialize(json);
    return json;
  }

  public fromJson(json: any) {
    this.Deserialize(json);
  }

  protected buildPGContext(context: PGContext) {
    // context.addRow('基本属性', 'id', '编号', 'string', baseEntity.id, '元数据运行期ID');
    context.addRow('修改历史', 'createdBy', '创建人', EnumDataType.String, this.createdBy, false, '元数据的创建人', '', 'PGRowAccountValue');
    context.addRow('修改历史', 'createdOn', '创建时间', EnumDataType.DateTime, this.createdOn, false, '元数据的创建时间', '', '');
    context.addRow('修改历史', 'modifiedBy', '修改人', EnumDataType.String, this.modifiedBy, false, '元数据的最后修改人', '', 'PGRowAccountValue');
    context.addRow('修改历史', 'modifiedOn', '修改时间', EnumDataType.DateTime, this.modifiedOn, false, '元数据的最后修改时间', '', '');
    context.addRow('基本属性', 'status', '状态', EnumDataType.Reference, this.status, true, '数据创建时的初始状态', 'EnumElementStatus', 'PGRowEnumValue');
  }

  /**
   * 元数据发生修改，则修改持久化状态
   * 1、如果持久化状态为None，代表已经持久化，则改为Update
   * 2、其他状态，不发生变更
   * @param isRestore 删除的元素是否恢复为修改状态
   */
  public modify(isRestore = false) {
    if (this.persistenceStatus === EnumPersistenceStatus.None) {
      this.persistenceStatus = EnumPersistenceStatus.Update;
    }
    if (isRestore) {
      if (this.persistenceStatus === EnumPersistenceStatus.Delete || this.persistenceStatus === EnumPersistenceStatus.Remove) {
        this.persistenceStatus = EnumPersistenceStatus.Update;
      }
    }
  }
}
